import * as React from "react"
import styles from "./styles.module.scss";

export const WarningCanvas = ({className}: {className: string}) => (
    <svg
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        x={0}
        y={0}
        viewBox="0 0 24.64 22.73"
        width="1em" height="1em" fill="currentColor"
        xmlSpace="preserve"
        className={className}
    >
        <g id="_x32_9tnie.tif_00000023238843144099879320000007747083681204065688_">
            <path
                d="M20.85 16c-.1.36-.16.74-.32 1.07-.58 1.19-1.56 1.79-2.89 1.8-2.46.01-4.93 0-7.39 0H6.52c-1 0-1.85-.35-2.47-1.14-.79-1-.97-2.12-.41-3.27.47-.96 1.04-1.87 1.58-2.8C6.58 9.28 7.96 6.9 9.34 4.52c.5-.87 1.22-1.42 2.22-1.61 1.13-.22 2.46.29 3.06 1.27.65 1.05 1.25 2.12 1.87 3.18 1.27 2.19 2.53 4.38 3.8 6.57.28.49.49 1 .57 1.56-.01.17-.01.34-.01.51zm-8.8 1.46c1.84 0 3.68.01 5.52-.01.28 0 .58-.05.83-.16.95-.41 1.3-1.52.77-2.44-.57-1-1.15-1.99-1.72-2.99-1.28-2.21-2.56-4.43-3.83-6.64-.22-.38-.5-.68-.91-.83-.83-.31-1.66 0-2.13.81-1.47 2.55-2.95 5.1-4.42 7.65-.42.72-.85 1.43-1.24 2.17-.3.57-.24 1.15.11 1.69s.88.77 1.51.77c1.84-.02 3.68-.02 5.51-.02z"
            />
            <path
                d="m12.98 8.86-.21 3.6c-.01.16 0 .33-.03.49-.06.33-.34.55-.67.55-.33-.01-.6-.22-.64-.55-.05-.45-.07-.9-.09-1.35-.06-.92-.11-1.83-.17-2.75-.05-.77.63-1.31 1.29-1 .42.2.55.57.52 1.01zM11.19 15c.01-.49.41-.89.9-.89.5 0 .88.4.88.92 0 .48-.4.88-.88.88-.5 0-.9-.41-.9-.91z"
            />
        </g>
    </svg>
)

export const Danger = () => <WarningCanvas className={styles.danger} />
